"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientSubsystem = void 0;
const ee_ts_1 = require("ee-ts");
const Either = __importStar(require("fp-ts/Either"));
class ClientSubsystem extends ee_ts_1.EventEmitter {
    constructor(manifest, channel, react, regionConfig, entityManagement) {
        super();
        this.manifest = () => {
            return this._manifest;
        };
        this.messengerChannel = () => {
            return this._channel;
        };
        this.createClientOnlyEntity = (id, initialState) => {
            return this._entityManagement.createClientOnlyEntity(id, initialState);
        };
        this.removeEntity = (instanceID) => {
            this._entityManagement.removeEntity(instanceID);
        };
        this.getEntityList = () => {
            return this._entityManagement.getEntityList();
        };
        this.renderUI = (node) => {
            this._react.injectNode(node);
        };
        this.destroyUI = () => {
            this._react.destroyNode();
        };
        this.readRegionConfig = (codec) => {
            const decoded = codec.decode(this._regionConfig);
            if (Either.isLeft(decoded))
                return undefined;
            return decoded.right;
        };
        this._manifest = manifest;
        this._channel = channel;
        this._react = react;
        this._regionConfig = regionConfig;
        this._entityManagement = entityManagement;
    }
}
exports.ClientSubsystem = ClientSubsystem;
//# sourceMappingURL=ClientSubsystem.js.map